"use strict";

var deliveryAutocomplete, moveAutocomplete;

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueResource from 'vue-resource';
import AsyncComputed from 'vue-async-computed';
import moment from 'moment';
import 'Common/bootstrap-datepicker.js';

Vue.use(VeeValidate);
Vue.use(VueResource);
Vue.use(AsyncComputed);
VeeValidate.Validator.installDateTimeValidators(moment);

// Common dictionary updates
VeeValidate.Validator.updateDictionary({
	en: {
		messages: {
			required: () => "Required",
			digits: () => "Must be 5 digits only",
			numeric: () => "Numbers only",
			email: () => "Invalid email address",
			min_value: () => "Must be at least 1"
		}
	}
});

Vue.directive('datepicker', {
	bind: function (el, binding, vnode) {
		$(el).datepicker({
			autoclose: true,
			todayHighlight: true,
			format: "m/d/yyyy"
		}).on("changeDate", function (e) {
			Vue.set(vnode.context, binding.expression, e.format());
		});
	},
	update: function (el, binding) {
		var tmp = binding.value === "" || binding.value === null ? null : new Date(binding.value);
		$(el).datepicker('setDate', tmp);
	}
});

var bundles = window.data.Bundles;
for (var b = 0; b < bundles.length; b++) {
	bundles[b].Qty = "";
	bundles[b].Selected = false;
}
var vm = null;

function initVue() {

	vm = new Vue({
		el: "#getPortableQuote",
		data: {
			firstName: "",
			lastName: "",
			phoneNumber: "",
			email: "",
			deliveryDate: moment().format("M/D/YYYY"),
			monthsNeeded: 1,
			deliveryAddress: "",
			deliveryZip: "",
			moveAddress: "",
			moveZip: "",
			location: "L",
			category: "R",
			quoteInterest: "R",
			quoteNeeds: "S",
			bundleInfo: bundles,
			insurance: false,
			showPromoCode: false,
			promoCode: "",
			barrAddress: "1423 Planeview Dr",
			barrZip: "54904",
			distanceError: false,
			moveAddressError: false,
			moveZipError: false,
			submitting: false,
			deliveryNeeded: true
		},
		computed: {
			// Cost per month for the unit. Rates differ between storage on-site and storage at Barr
			monthCost() {
				return parseInt(this.monthsNeeded) * (this.location === "L"
					? window.data.Rates.MonthlyRate
					: window.data.Rates.OnSiteMonthlyRate);
			},

			// Cost for delivering the container to the first (delivery) site
			deliveryCost() {

				// If the unit is to be stored on-site, charge one way (Deliver Empty)
				// If the unit is to be stored at Barr, charge round trip (Deliver Empty + Return Full)
				var distanceMultiplier = this.location === "S" ? 2 : 1;

				// If the location is within the flat-rate delivery area, charge the flat rate, otherwise charge the per-mile rate
				// for the qualifying trips.
				return (window.data.Rates.FlatRateRadius <= 1 || this.deliveryDistance > window.data.Rates.FlatRateRadius)
					? this.deliveryDistance * distanceMultiplier * window.data.Rates.MilesRate
					: window.data.Rates.InnerFlatRate * distanceMultiplier;
			},

			// Cost for moving the container from the first (delivery) site to the second (move) site (Curb to Curb)
			// This only applies when the customer is moving, and does not store the unit at Barr
			moveCost() {

				// If this is not a curb-to-curb move, this cost does not apply
				if (this.quoteNeeds === "S" || this.location === "S") {
					return 0;
				}

				// If the location is within the flat-rate delivery area, charge the flat rate, otherwise charge the per-mile rate
				// for the qualifying trips.
				return (window.data.Rates.FlatRateRadius <= 1 || this.moveDistance > window.data.Rates.FlatRateRadius)
					? this.moveDistance * window.data.Rates.MilesRate
					: window.data.Rates.InnerFlatRate;
			},

			// Cost for pickup/return of the container from the customer
			// - When moving, this is rated from the move location, otherwise it's rated from the delivery location
			returnCost() {

				// If the unit is to be stored on-site, charge one way (Return Empty)
				// If the unit is to be stored at Barr, charge round trip (Deliver Full + Return Empty)
				var distanceMultiplier = this.location === "S" ? 2 : 1;

				// If the location is within the flat-rate delivery area, charge the flat rate, otherwise charge the per-mile rate
				// for the qualifying trips.
				return (window.data.Rates.FlatRateRadius <= 1 || this.returnDistance > window.data.Rates.FlatRateRadius)
					? this.returnDistance * distanceMultiplier * window.data.Rates.MilesRate
					: window.data.Rates.InnerFlatRate * distanceMultiplier;
			},

			// Cost for any bundled items
			bundleCost() {
				var cost = 0;
				for (var x = 0; x < this.bundleInfo.length; x++) {
					if (this.bundleInfo[x].Selected) {
						cost += parseInt(this.bundleInfo[x].Qty) * parseFloat(this.bundleInfo[x].Price);
					}
				}
				return cost;
			},

			// Cost for insurance
			insuranceCost() {
				var cost = 0;
				if (this.insurance) cost = parseInt(this.monthsNeeded) * window.data.Rates.InsuranceRate;
				return cost;
			},

			totalEstimate() {
				return window.data.Rates.FlatRate + this.insuranceCost + this.bundleCost + this.monthCost + this.deliveryCost + this.moveCost + this.returnCost;
			},

			showEstimate() {

				if (!window.data.Rates.ShowQuote) return false;

				if (this.deliveryAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.deliveryZip)) return false;
				if (this.quoteNeeds !== "S" &&
					(this.moveAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.moveZip))) return false;

				if (this.deliveryDistance + this.moveDistance + this.returnDistance <= 0) return false;

				return !this.distanceError && this.totalEstimate > 0;
			},

			renting() {
				return this.quoteInterest === 'R';
			},

			showDeliveryFields() {
				if(this.renting) return true;
				return this.deliveryNeeded;
			}
		},

		asyncComputed: {
			// Distance to first (delivery) site, measured from Barr.
			deliveryDistance() {

				// If the delivery address is not populated, do not calculate
				if (this.deliveryAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.deliveryZip)) return Promise.resolve(0);

				return this.getDistance(this.barrAddress, this.barrZip, this.deliveryAddress, this.deliveryZip);
			},

			// Distance from first site to second site, direct (Curb to Curb)
			// Only applies in moving situations, when the unit is not stored at Barr
			moveDistance() {

				// If this is not a curb-to-curb move, then this distance does not apply
				if (this.quoteNeeds === "S" || this.location === "S") {
					return Promise.resolve(0);
				}

				// If the delivery and move addresses are not populated, do not calculate
				if (this.deliveryAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.deliveryZip)) return Promise.resolve(0);
				if (this.moveAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.moveZip)) return Promise.resolve(0);

				return this.getDistance(this.deliveryAddress, this.deliveryZip, this.moveAddress, this.moveZip, null);
			},

			// Distance to the pickup site, which is either same as the delivery site, or different if it is a move situation
			returnDistance() {
				// If this is a storage situation, then it's the same distance as the delivery
				if (this.quoteNeeds === "S") return Promise.resolve(this.deliveryDistance);

				// If the delivery address is not populated, do not calculate
				if (this.moveAddress == "" || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.moveZip)) return Promise.resolve(0);

				if (this.moveAddress == this.deliveryAddress && this.moveZip == this.deliveryZip) return this.deliveryDistance;

				return this.getDistance(this.moveAddress, this.moveZip, this.barrAddress, this.barrZip);
			}
		},
		watch: {
			bundleInfo: {
				handler() {
					for (var x = 0; x < this.bundleInfo.length; x++) {
						if (this.bundleInfo[x].Selected && this.bundleInfo[x].Qty === "") this.bundleInfo[x].Qty = "1";
						else if (!this.bundleInfo[x].Selected) this.bundleInfo[x].Qty = "";
					}
				},
				deep: true
			},
			deliveryNeeded(isNeeded) {
				if(!isNeeded && !this.renting) {
					this.deliveryAddress = "";
					this.deliveryZip = "";
				}
			}
		},
		filters: {
			asMoney(n) {
				var c = 2,
					d = ".",
					t = ",",
					s = n < 0 ? "-" : "",
					i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
					j = (j = i.length) > 3 ? j % 3 : 0;
				return "$" + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
			}
		},
		mounted() {
			let self = this;

			self.toggleQuoteNeeds();
		},
		methods: {
			toggleQuoteNeeds() {
				if (this.quoteNeeds === "S") {
					this.moveAddressError = false;
					this.moveZipError = false;
				}
			},
			moveAddressValid() {
				if (this.quoteNeeds === "S") return true;
				return this.moveAddress !== null && this.moveAddress.trim() !== "";
			},
			moveZipValid() {
				if (this.quoteNeeds === "S") return true;
				if (this.moveZip === null || this.moveZip.trim() === "") return false;
				return /^[0-9]{5}(?:-[0-9]{4})?$/.test(this.moveZip);
			},
			formatPhoneNum() {
				var x = this.phoneNumber.replace(/\D/g, '').match(/([2-9]\d{0,2})(\d{0,3})(\d{0,4})/);
				if (typeof (x) == "undefined" || x == null) return;
				this.phoneNumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
			},
			getDistance(originAddr, originZip, destAddr, destZip) {
				var self = this;

				return new Promise((resolve, reject) => {
					var origin = originAddr + " " + originZip;
					var destination = destAddr + " " + destZip;

					var service = new google.maps.DistanceMatrixService;
					service.getDistanceMatrix({
						origins: [origin],
						destinations: [destination],
						travelMode: "DRIVING",
						unitSystem: google.maps.UnitSystem.IMPERIAL,
						avoidHighways: false,
						avoidTolls: false
					}, (response, status) => {
						if (status !== 'OK') {
							reject("Error was: " + status);
						} else {
							var distance = Math.ceil(response.rows[0].elements[0].distance.value / 1609.34);

							if (window.data && window.data.Rates && window.data.Rates.MaxServiceRadius > 0 && window.data.Rates.MaxServiceRadius < distance) {
								self.distanceError = true;
							} else self.distanceError = false;

							resolve(distance);
						}
					});

				});
			},
			submitQuote() {
				var self = this;

				console.log('got here');
				
				this.moveAddressError = !this.moveAddressValid();
				this.moveZipError = !this.moveZipValid();

				this.$validator.validateAll().then(() => {
					console.log('got here 2');
					if (!self.distanceError && !self.moveAddressError && !self.moveZipError) {
						console.log('got here 3');
						self.submitting = true;

						var rec = {
							Category: self.category,
							Needs: self.quoteNeeds,
							DeliveryDate: moment(self.deliveryDate, "M/D/YYYY"),
							DeliveryZip: self.deliveryZip,
							DeliveryAddress: self.deliveryAddress,
							MoveZip: self.moveZip,
							MoveAddress: self.moveAddress,
							StorageLocation: self.location,
							EstimatedMonthsNeeded: parseInt(self.monthsNeeded),
							Email: self.email,
							PhoneNumber: self.phoneNumber,
							FirstName: self.firstName,
							LastName: self.lastName,
							DistanceCost: parseFloat(self.deliveryCost) + parseFloat(self.returnCost),
							Distance: self.deliveryDistance,
							MoveDistance: self.moveDistance,
							MoveDistanceCost: self.moveCost,
							HasInsurance: self.insurance,
							PromoCode: self.promoCode,
							Estimate: self.totalEstimate,
							FinalPickupDistance: self.returnDistance,
							SubmitBundles: [],
							Interest: self.quoteInterest
						}
						for (var x = 0; x < self.bundleInfo.length; x++) {
							if (self.bundleInfo[x].Selected) {
								rec.SubmitBundles.push({
									BundleId: self.bundleInfo[x].Id,
									Qty: self.bundleInfo[x].Qty
								});
							}
						}

						self.$http.post("/Portable/Quote", rec).then(resp => {
							var data = resp.body;
							if (data) {
								window.location.href = "/Portable/ThankYou";
								return;
							}
							self.submitting = false;
						}).catch(err => {
							console.error(err);
							self.submitting = false;
						});
					}
				}).catch(() => {
					console.log(self.errors);
				});
			}
		}
	});
}

window.initAutocomplete = function() {
	initVue();
	
	// Create the autocomplete object, restricting the search to geographical
	// location types.
	deliveryAutocomplete = new google.maps.places.Autocomplete((document.getElementById('deliveryAddress')), { types: ['geocode'] });
	moveAutocomplete = new google.maps.places.Autocomplete((document.getElementById('moveAddress')), { types: ['geocode'] });

	// When the user selects an address from the dropdown, populate the address
	// fields in the form.
	deliveryAutocomplete.addListener('place_changed', fillInDeliveryAddress);
	moveAutocomplete.addListener('place_changed', fillInMoveAddress);

}

function fillInDeliveryAddress() {
	// Get the place details from the autocomplete object.
	var place = deliveryAutocomplete.getPlace();
	var addr = getPlaceAddr(place);

	vm.deliveryAddress = addr.streetAddr;
	vm.deliveryZip = addr.zipCode;
	vm.$validator.validate('deliveryAddress', addr.streetAddr);
	vm.$validator.validate('deliveryZip', addr.zipCode);
}

function fillInMoveAddress() {
	// Get the place details from the autocomplete object.
	var place = moveAutocomplete.getPlace();
	var addr = getPlaceAddr(place);

	vm.moveAddress = addr.streetAddr;
	vm.moveZip = addr.zipCode;

	vm.$nextTick(() => {
		vm.moveAddressError = !vm.moveAddressValid();
		vm.moveZipError = !vm.moveZipValid();
	});
}

function getPlaceAddr(place) {
	var streetNum = "";
	var route = "";
	var postalCode = "";

	// Get each component of the address from the place details
	// and fill the corresponding field on the form.
	for (var i = 0; i < place.address_components.length; i++) {
		var addressType = place.address_components[i].types[0];
		if (addressType === "street_number") {
			streetNum = place.address_components[i]["short_name"];
		} else if (addressType === "route") {
			route = place.address_components[i]["long_name"];
		} else if (addressType === "postal_code") {
			postalCode = place.address_components[i]["short_name"];
		}
	}

	return {
		streetAddr: streetNum + " " + route,
		zipCode: postalCode
	}
}

Number.prototype.formatMoney = function (c, d, t) {
	var n = this,
		c = isNaN(c = Math.abs(c)) ? 2 : c,
		d = d == undefined ? "." : d,
		t = t == undefined ? "," : t,
		s = n < 0 ? "-" : "",
		i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
		j = (j = i.length) > 3 ? j % 3 : 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};


// WEBPACK FOOTER //
// ./src/portable.js